export default "__VITE_ASSET__e5a1419d__"